export const environment = {
    production: false,
    identityUrl: 'https://identity-v2-dev.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://assess-v2-dev.nside.io',
    apiBaseUrl: 'https://assess-api-dev.nside.io',
    tipsApiBaseUrl: 'https://tips-v2-dev.nside.io'
};
